<div [ngSwitch]="column().type">
  <ng-container *ngIf="column().format">
    {{ column().format!(row()) }}
  </ng-container>

  <app-status-column
    *ngSwitchCase="ColumnType.STATUS"
    [config]="column().columnConfig!"
    [value]="row()[column().id]"
  >
  </app-status-column>

  <app-status-column
    *ngSwitchCase="ColumnType.STATUS_ACTION"
    class="status-action-cell"
    [config]="column().columnConfig!"
    [value]="row()[column().id]"
    (click)="onStatusActionClick()"
    [filled]="true"
  >
  </app-status-column>

  <span *ngSwitchCase="ColumnType.CURRENCY">
    {{ row()[column().id] | currency: 'BRL' : 'R$' | emptyValue }}
  </span>
  <span *ngSwitchCase="ColumnType.DATE">
    {{ row()[column().id] | date: 'dd/MM/yyyy' | emptyValue }}
  </span>
  <app-boolean-column *ngSwitchCase="ColumnType.BOOLEAN" [value]="row()[column().id]">
  </app-boolean-column>
  <span *ngSwitchCase="ColumnType.MASK">
    {{ row()[column().id] | mask: column().mask! | emptyValue }}
  </span>
  <span
    *ngSwitchCase="ColumnType.NAME"
    matTooltip="{{ row()[column().id] }}"
    matTooltipPosition="above"
  >
    {{ row()[column().id] | truncate: 30 | emptyValue }}
  </span>

  <span *ngSwitchCase="ColumnType.SELECT_DATA" matTooltip="{{ row()[column().id]?.label ?? row()[column().id] }}">
    {{ (row()[column().id]?.label ?? row()[column().id]) | truncate: 30 | emptyValue }}
  </span>

  <mat-form-field *ngSwitchCase="ColumnType.SELECT_EDITABLE" appearance="outline" class="w-100">
    <mat-select [(ngModel)]="row()[column().id]" [placeholder]="column().name">
      <mat-option *ngFor="let opt of column().options" [value]="opt[column().optionValue!]">
        {{ opt[column().optionLabel!] }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <span *ngSwitchCase="ColumnType.CPF_CNPJ">
    {{
      row()[column().id]
        | mask: (row()[column().id]?.length === CPF_SIZE ? CPF_MASK : (CNPJ_MASK | emptyValue))
    }}
  </span>
  <div *ngSwitchCase="ColumnType.COMPONENT" class="d-flex justify-content-center w-100">
    <ng-container #dynamicComponentContainer> </ng-container>
  </div>
  <span class="default-string" *ngSwitchDefault>
    @if (!column().format) {
      {{ row()[column().id] | emptyValue }}
    }
  </span>
</div>
